import { PreAccessDocumentsTab } from "../components";
import Documents, { DocumentsProps } from "../Documents";
import { useDocumentsTabWithPreAccess } from "./useDocumentsTabWithPreAccess";

const DocumentsTabWithPreAccess = ({ descriptionText, type }: DocumentsProps): JSX.Element => {
  const { hasFullAccess } = useDocumentsTabWithPreAccess();

  if (!hasFullAccess) {
    return <PreAccessDocumentsTab isRounded={type === "seed"} />;
  }

  return <Documents descriptionText={descriptionText} type={type} />;
};

export default DocumentsTabWithPreAccess;
